'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxModule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

exports.action = action;
exports.reducer = reducer;

var _decorators = require('./decorators');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function buildActionName(prefix, name) {
  return prefix + '_' + name;
}

/*
 * ACTION (DECORATOR)
 *
 * Create a Flux Standard Action (FSA) based on the return values.
 *
 * TODO: An FSA has the following attributes.
 * - type
 * - payload
 * - meta
 * - error
 */
function action(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;

  if (options === void 0) {
    options = {};
  }
  return function _actionWrap(target, key, descriptor) {
    var original = descriptor.value;
    return (0, _decorators.wrapMethod)(target, key, descriptor, function _action() {
      var result = original.apply(undefined, arguments);
      if (result === void 0) {
        result = {};
      }

      var payload = result['payload'];
      if (payload === void 0) {
        payload = options['payload'] || null;
      }

      var meta = result['meta'];
      if (meta === void 0) {
        meta = options['meta'] || {};
      }

      return {
        type: this.actionType(name),
        payload: payload,
        meta: meta
      };
    });
  };
}

/*
 * REDUCER (DECORATOR)
 *
 * Record a reducer for a Flux Standard Action (FSA) specified with @action
 *
 * TODO: An FSA has the following attributes.
 * - type
 * - payload
 * - meta
 * - error
 */
function reducer(name) {
  return function _reducerWrap(target, key, descriptor) {
    if (!target._reducers) {
      target._reducers = {};
    }
    target._reducers[name] = key;
  };
}

var ReduxModule = exports.ReduxModule = (_class = function () {
  function ReduxModule(stateKey) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;

    _classCallCheck(this, ReduxModule);

    if (options === void 0) {
      options = {};
    }

    this.stateKey = stateKey;
    this.initialState = options['initialState'] || {};
    this.actionPrefix = options['actionPrefix'];

    this.reducers = this._createReducerMap();
  }

  _createClass(ReduxModule, [{
    key: 'actionType',
    value: function actionType(name) {
      var prefix = void 0;
      if (this.actionPrefix) {
        prefix = this.actionPrefix.toUpperCase();
      } else if (this.stateKey) {
        prefix = this.stateKey.toUpperCase();
      } else {
        throw 'Unable to locate actionPrefix or stateKey for ' + this;
      }
      return prefix + '_' + name;
    }
  }, {
    key: '_createReducerMap',
    value: function _createReducerMap() {
      var ret = {};
      if (this._reducers !== void 0) {
        var reducerCb = void 0;
        var methodName = void 0;
        var thisModule = this;

        Object.keys(thisModule._reducers).map(function (name) {
          methodName = thisModule._reducers[name];
          reducerCb = thisModule[methodName];
          ret[thisModule.actionType(name)] = reducerCb.bind(thisModule);
        });
      }
      return ret;
    }
  }, {
    key: 'reducer',
    value: function reducer(state, action) {
      if (state === void 0) {
        return this.initialState;
      }

      var reducers = this.reducers;
      var reducerForType = reducers[action.type];
      if (reducerForType) {
        return reducerForType(state, action.payload, action.meta);
      }

      return state;
    }
  }, {
    key: 'getState',
    value: function getState(state) {
      return state[this.stateKey];
    }
  }]);

  return ReduxModule;
}(), (_applyDecoratedDescriptor(_class.prototype, 'reducer', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'reducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getState', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'getState'), _class.prototype)), _class);